function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16 24a8 8 0 110-16 8 8 0 010 16z",
  fill: "#2F80ED"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.699 19.261l4.819-4.82a.962.962 0 00-1.359-1.36l-4.14 4.141-2.178-2.179a.962.962 0 00-1.36 1.36l2.858 2.858a.957.957 0 001.36 0z",
  fill: "#fff"
});

var SvgIconFinished = function SvgIconFinished(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDI0QzExLjU4MTYgMjQgOCAyMC40MTg0IDggMTZDOCAxMS41ODE2IDExLjU4MTYgOCAxNiA4QzIwLjQxODQgOCAyNCAxMS41ODE2IDI0IDE2QzI0IDIwLjQxODQgMjAuNDE4NCAyNCAxNiAyNFoiIGZpbGw9IiMyRjgwRUQiLz4KPHBhdGggZD0iTTE1LjY5ODggMTkuMjYxMkwyMC41MTc4IDE0LjQ0MDZDMjAuODk0NyAxNC4wNjUyIDIwLjg5MzcgMTMuNDU2NiAyMC41MTc4IDEzLjA4MTFDMjAuMTQzMyAxMi43MDYyIDE5LjUzMzggMTIuNzA2MiAxOS4xNTg5IDEzLjA4MTFMMTUuMDE5MSAxNy4yMjJMMTIuODQxMSAxNS4wNDM0QzEyLjQ2NTYgMTQuNjY4NSAxMS44NTY2IDE0LjY2ODUgMTEuNDgxNyAxNS4wNDM0QzExLjEwNjIgMTUuNDE4OSAxMS4xMDYyIDE2LjAyODQgMTEuNDgxNyAxNi40MDI5TDE0LjMzOTQgMTkuMjYxMkMxNC41Mjc0IDE5LjQ0OTIgMTQuNzczIDE5LjU0MjkgMTUuMDE5MSAxOS41NDI5QzE1LjI2NTIgMTkuNTQyOSAxNS41MTA5IDE5LjQ0OTIgMTUuNjk4OCAxOS4yNjEyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgIconFinished as ReactComponent };